/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ItemImage_item$ref = any;
type LazyImageWrapper_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SharedProductCarouselItem_edge$ref: FragmentReference;
export type SharedProductCarouselItem_edge = {|
  +cmsData: ?{|
    +title: ?string,
    +description: ?string,
  |},
  +node: ?{|
    +localizedPdpUrl: ?string,
    +creators: ?$ReadOnlyArray<?{|
      +attribution: ?string,
      +creator: ?{|
        +displayName: ?string
      |},
    |}>,
    +$fragmentRefs: LazyImageWrapper_item$ref & ItemImage_item$ref,
  |},
  +$refType: SharedProductCarouselItem_edge$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SharedProductCarouselItem_edge",
  "type": "CmsItemsEdge",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cmsData",
      "storageKey": null,
      "args": null,
      "concreteType": "CmsData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "Item",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "LazyImageWrapper_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "ItemImage_item",
          "args": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "localizedPdpUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "creators",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemCreator",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "attribution",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "creator",
              "storageKey": null,
              "args": null,
              "concreteType": "Creator",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayName",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6eb700a795b6c3d7b1476992363d64f0';
module.exports = node;
